import { render } from "./OpenRequestReservation.vue?vue&type=template&id=2267b464"
import script from "./OpenRequestReservation.vue?vue&type=script&lang=js"
export * from "./OpenRequestReservation.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__